module.exports = __webpack_public_path__ + "static/media/main_visual_skid_steer_loaders_1900_r_manitou.e3967e62.png";